export default "__VITE_ASSET__CQ5G65Mh__"